import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { hotelPath } from 'app/hooks/data/hotels/useHotel';
import type { DayRoomAccess } from 'app/typings/core/admin/hotel/dayRoomAccess';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUpdateDayRoomAccess(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: DayRoomAccess) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.updateDayRoomAccess,
          params: { id: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.hotelEntities, { id: hotelId.toString() }],
      });
      queryClient.invalidateQueries({
        queryKey: [hotelPath, { hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to save Day access.');
    },
  });
}
